import {PrintGuideParams} from 'domain/usecases';
import {makeGetPrintGuide} from 'main/factories/usecases/private/authorizations';

export const getPrintGuide = async (params: PrintGuideParams) => {
	const response = await makeGetPrintGuide().get(params);
	return response;
};
